<!--
 * @Author: yong.wang webwang1@outlook.com
 * @Date: 2026-08-06 16:32:58
 * @LastEditTime: 2026-08-20 17:20:40
 * @LastEditors: yong.wang webwang1@outlook.com
 * @Description: 二维码生成页面 - 使用 Canvas API 实现
 *   核心改进:完全用 Canvas 2D API 绘制 QR 码 + 文字,不再依赖 html2canvas 截图
 *   - 避免 html2canvas 在 Vite 8 下的 ESM 互操作问题
 *   - 用 toBlob + binary 方式打包 zip,避免 base64 解析问题
 *   - 批量并发处理,性能更好
 *   - 离屏 canvas 绘制,不影响主 DOM
 * Copyright (c) 2026 by webwang1, All Rights Reserved.
-->
<template>
  <div class="main">
    <div class="queryResult">{{ $t('qrCodePage.title') }}</div>
    <div class="content">
      <span style="flex: 0.5" />
      <site-m class="chooseMDisplay" ref="sitem"></site-m>
      <shop-m class="chooseMDisplay" ref="shopm" @shoplist-changed="onShopListChanged"></shop-m>
      <span style="flex: 0.5" />
    </div>

    <div style="text-align: center; padding-top: 100px; margin-bottom: 20px">
      <a-button
        :loading="loading"
        type="primary"
        style="
          flex: 0;
          height: 38px;
          background: #2ca70e;
          border-color: #2ca70e;
        "
        v-on:click="downloadQRcode()"
        >{{ $t('qrCodePage.saveQrCode') }}</a-button
      >
    </div>
 <div class="qr-grid">
      <div
        v-for="(item, index) in shopQrData"
        :key="index"
        class="qr-card"
        :id="'qrcodeWapper' + index"
      >
        <div class="qr-card-head">{{ item.locationName || item.name }}</div>
        <div class="qr-card-image">
          <img
            v-if="item.dataUrl && item.dataUrl.length > 0"
            :src="item.dataUrl"
            alt="QR Code"
            class="qr-img"
          />
          <div v-else class="qr-placeholder">{{ $t('qrCodePage.noQrCode') }}</div>
        </div>
        <div class="qr-card-code">{{ item.nameEn }}</div>
        <div class="qr-card-name">{{ item.name }}</div>
      </div>
      <div v-if="shopQrData.length === 0" class="qr-empty">
        {{ $t('qrCodePage.selectShopFirst') || 'Please select shops first' }}
      </div>
    </div>
    <a-modal
      v-model:open="visible"
      :footer="null"
      :closable="false"
      style="height: 20px"
    >
      <p>{{ qrcodeStatusText }}</p>
    </a-modal>
  </div>
</template>
<style scoped>
.main {
  width: 100%;
  height: calc(100% - 120px);
  overflow: auto;
}

.main::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}
.main::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #c6cad1;
}

.main::-webkit-scrollbar-track {
  border-radius: 8px;
  background: #edeef0;
}

.content {
  margin: 0 auto;
  flex: 0 0 160px;
  display: flex;
  width: 80%;
}

.queryResult {
  text-align: center;
  padding: 30px 0px 10px 0px;
  color: #3d4d6b;
  font-size: 15px;
  font-weight: 500;
}

.chooseMDisplay {
  margin-right: 8px;
  flex: 1;
}

.qr-grid {
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 0 20px 30px;
  box-sizing: border-box;
  align-items: start;
}

.qr-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 1px solid #eceff3;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(61, 77, 107, 0.08);
  padding: 16px 14px 14px;
  box-sizing: border-box;
  transition: box-shadow 0.2s ease;
}

.qr-card:hover {
  box-shadow: 0 4px 16px rgba(61, 77, 107, 0.16);
}

.qr-card-head {
  font-size: 14px;
  font-weight: 600;
  color: #3d4d6b;
  text-align: center;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 12px;
}

.qr-card-image {
  width: 180px;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #edeef0;
  border-radius: 6px;
  padding: 6px;
  box-sizing: border-box;
}

.qr-img {
  width: 100%;
  height: 100%;
  display: block;
}

.qr-placeholder {
  color: #b3b9c4;
  font-size: 13px;
}

.qr-card-code {
  font-size: 13px;
  color: #7a8494;
  margin-top: 10px;
  text-align: center;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qr-card-name {
  font-size: 13px;
  color: #7a8494;
  margin-top: 4px;
  text-align: center;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.qr-empty {
  color: #b3b9c4;
  font-size: 14px;
  text-align: center;
  padding: 40px 20px;
}

@media (max-width: 1240px) {
  .content {
    width: 94%;
    flex: 0 0 45%;
    flex-direction: column;
  }

  .chooseMDisplay {
    margin-right: 0px;
    flex: 1;
    align-items: center;
    margin-bottom: 10px;
  }
}
</style>
<script>
import { resolveCJS } from '@/assets/utils/cjs-interop';
// 参考 M 的实现,完全用 Canvas 2D API 绘制,移除 html2canvas 依赖
// qrcode 和 jszip 是 CommonJS 包,用 resolveCJS 提取真实导出避免 Vite 8 互操作问题
import * as jszipNS from 'jszip';
import * as QRCodeNS from 'qrcode';
import ShopM from '../../components/ShopM';
import SiteM from '../../components/SiteM';
const QRCode = resolveCJS(QRCodeNS, 'qrcode');
const JSZip = resolveCJS(jszipNS, 'jszip');
// 库导入后的类型检查日志,确认 resolveCJS 正确提取了真实导出
console.log('[Import] QRCode:', {
  type: typeof QRCode,
  hasToCanvas: typeof QRCode?.toCanvas === 'function',
  keys: QRCode ? Object.keys(QRCode).slice(0, 10) : [],
});
console.log('[Import] JSZip:', {
  type: typeof JSZip,
  isFunction: typeof JSZip === 'function',
  hasFolder: typeof JSZip?.prototype?.folder === 'function',
  hasGenerateAsync: typeof JSZip?.prototype?.generateAsync === 'function',
});

export default {
  name: 'Qrcode',
  data() {
    return {
      loading: false,
      visible: false,
      qrcodeStatusText: '',
      // 页面展示用的二维码数据(由 generateShopQrData 生成)
      shopQrData: [],
      // 二维码样式配置(匹配参考图:512x700 纯白背景+居中QR+下方文字)
      qrCodeConfig: {
        container: {
          width: 512,
          height: 700,
          backgroundColor: '#ffffff',
          fontFamily: 'Microsoft JhengHei',
        },
        qrCode: {
          size: 400,
          marginTop: 60,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: 'M',
        },
        // 地点/品牌(参考图中"Canon") - 放在 QR 码下方、中文名上方
        locationInfo: {
          fontSize: '28px',
          color: '#000000',  
           lineHeight: 34,
          marginTop: 30,
          maxLineLength: 16,
        },
        // 中文名(参考图中"奧運")
        nameZh: {
          fontSize: '28px',
          color: '#000000',
          lineHeight: 34,
          marginTop: 10,
          maxLineLength: 16,
        },
        // 英文名(参考图中"OLY VEM 2")
        nameEn: {
          fontSize: '28px',
          color: '#000000',
          lineHeight: 34,
          marginTop: 10,
          maxLineLength: 16,
        },
      },
    };
  },
  components: { SiteM, ShopM },
  methods: {
    /**
     * 为单个商铺生成 QR 码图片
     * 参考 M 的 createSingleQRCode 方法
     * 展示图: 用 QRCode.toDataURL() 直接生成 base64,不依赖 canvas.toDataURL
     * 下载图: 用 Canvas 2D API 绘制完整卡片(含文字),toBlob 生成 JPEG
     */
    createSingleQRCode(shop, index) {
      console.log(`[QRCode #${index}] Start generating for shop:`, {
        cmsUid: shop.cmsUid,
        name: shop.name,
        nameEN: shop.nameEN,
        locationCode: shop.locationCode,
        hasShopLocation: !!shop.shopLocation,
      });
      return new Promise((resolve) => {
        try {
          const config = this.qrCodeConfig;

          // 验证 QR 码内容(cmsUid)
          const qrText = shop.cmsUid ? shop.cmsUid.toString() : '';
          if (!qrText) {
            console.error(`[QRCode #${index}] Shop cmsUid is empty, aborting:`, shop);
            resolve(null);
            return;
          }
          console.log(`[QRCode #${index}] QR text content: "${qrText}"`);

          const qrOptions = {
            width: config.qrCode.size,
            margin: 0,
            color: {
              dark: config.qrCode.colorDark,
              light: config.qrCode.colorLight,
            },
            errorCorrectionLevel: config.qrCode.correctLevel,
          };

          // ---- 第一步: 用 QRCode.toDataURL 直接获取展示用 base64 图片 ----
          if (typeof QRCode.toDataURL !== 'function') {
            console.error(`[QRCode #${index}] QRCode.toDataURL is not a function! QRCode=`, QRCode);
            resolve(null);
            return;
          }

          QRCode.toDataURL(qrText, qrOptions, (err, dataUrl) => {
            if (err) {
              console.error(`[QRCode #${index}] QRCode.toDataURL error:`, err);
              resolve(null);
              return;
            }
            console.log(`[QRCode #${index}] dataUrl generated: length=${dataUrl.length}`);

            // ---- 第二步: 用 Canvas 绘制完整卡片(用于下载,匹配参考图 512x700) ----
            const canvas = document.createElement('canvas');
            const canvasW = config.container.width;
            const canvasH = config.container.height;
            canvas.width = canvasW;
            canvas.height = canvasH;
            const ctx = canvas.getContext('2d');

            // 提前提取字段,供 onload 和 onerror 回调共用
            const locationName = shop.shopLocation ? shop.shopLocation.name : '';
            const locationCode = shop.locationCode || '';
            const nameZh = shop.name || '';          // 中文名
            const nameEn = shop.nameEN || '';         // 英文名

            // 1. 绘制白色背景
            ctx.fillStyle = config.container.backgroundColor;
            ctx.fillRect(0, 0, canvasW, canvasH);

            // 2. 将 dataUrl 图片加载为 Image,然后绘制到 canvas
            const qrImg = new Image();
            qrImg.crossOrigin = 'anonymous';
            qrImg.onload = () => {
              const qrX = (canvasW - config.qrCode.size) / 2;
              const qrY = config.qrCode.marginTop;
              ctx.drawImage(qrImg, qrX, qrY, config.qrCode.size, config.qrCode.size);

              // 3. 绘制文字区域(参考图:QR码下方 地点/品牌 → 中文名 → 英文名)
              let textY = qrY + config.qrCode.size + 10;

              // 3a. 地点/品牌(如"Canon") - 放在最上方
              const locationText = [locationName].filter(Boolean).join(' ');
              if (locationText) {
                ctx.fillStyle = config.locationInfo.color;
                ctx.font = `${config.locationInfo.fontSize} ${config.container.fontFamily}, sans-serif`;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'top';
                const maxChars = config.locationInfo.maxLineLength;
                const lines = [];
                for (let i = 0; i < locationText.length; i += maxChars) {
                  lines.push(locationText.substring(i, i + maxChars));
                }
                lines.forEach((line, lineIndex) => {
                  ctx.fillText(line, canvasW / 2, textY + lineIndex * config.nameZh.lineHeight);
                });
                textY += lines.length * config.nameZh.lineHeight + config.nameZh.marginTop;
              }

              // 3b. 中文名(如"奧運")
              if (nameZh) {
                ctx.fillStyle = config.nameZh.color;
                ctx.font = `${config.nameZh.fontSize} ${config.container.fontFamily}, sans-serif`;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'top';
                const maxChars = config.nameZh.maxLineLength;
                const lines = [];
                for (let i = 0; i < nameZh.length; i += maxChars) {
                  lines.push(nameZh.substring(i, i + maxChars));
                }
                lines.forEach((line, lineIndex) => {
                  ctx.fillText(line, canvasW / 2, textY + lineIndex * config.nameZh.lineHeight);
                });
                textY += lines.length * config.nameZh.lineHeight + config.nameEn.marginTop;
              }

              // 3c. 英文名(如"OLY VEM 2")
              if (nameEn) {
                ctx.fillStyle = config.nameEn.color;
                ctx.font = `${config.nameEn.fontSize} ${config.container.fontFamily}, sans-serif`;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'top';
                const maxChars = config.nameEn.maxLineLength;
                const lines = [];
                for (let i = 0; i < nameEn.length; i += maxChars) {
                  lines.push(nameEn.substring(i, i + maxChars));
                }
                lines.forEach((line, lineIndex) => {
                  ctx.fillText(line, canvasW / 2, textY + lineIndex * config.nameEn.lineHeight);
                });
              }

              // 4. 生成 JPEG blob 用于下载
              canvas.toBlob((blob) => {
                if (!blob) {
                  console.error(`[QRCode #${index}] canvas.toBlob returned null`);
                  resolve(null);
                  return;
                }
                console.log(`[QRCode #${index}] Blob generated: size=${blob.size} bytes`);

                // 5. 构造文件名
                const regex = /[\\/:*?"<>|]/g;
                let fileName = locationCode
                  ? (nameEn || nameZh || 'shop') + '_' + locationCode + '_' + shop.cmsUid
                  : (nameEn || nameZh || 'shop') + '_' + shop.cmsUid;
                fileName = fileName.replace(regex, '');
                if (!fileName) fileName = 'qrcode';
                fileName = fileName + '_' + String(index + 1).padStart(3, '0');

                resolve({
                  blob: blob,
                  fileName: fileName,
                  shopName: nameZh,
                  shopNameEn: nameEn,
                  index: index,
                  dataUrl: dataUrl,
                  locationName: locationName,
                  locationCode: locationCode,
                  cmsUid: shop.cmsUid,
                });
              }, 'image/jpeg', 0.95);
            };
            qrImg.onerror = (e) => {
              console.error(`[QRCode #${index}] Image load error for dataUrl:`, e);
              resolve({
                blob: null,
                fileName: '',
                 shopName: nameZh,
                  shopNameEn: nameEn,
                index: index,
                dataUrl: dataUrl,
                locationName: locationName,
                locationCode: locationCode,
                cmsUid: shop.cmsUid,
              });
            };
            qrImg.src = dataUrl;
          });
        } catch (err) {
          console.error(`[QRCode #${index}] createSingleQRCode exception:`, err);
          resolve(null);
        }
      });
    },

    /**
     * 批量生成 QR 码并打包为 ZIP 下载
     * 参考 M 的 download 方法
     */
    async downloadQRcode() {
      let shopList = this.$refs.shopm.ShopList;
      if (!shopList || shopList.length < 1) {
        this.$message.info(this.$t('eVoucherPage.shopIsEmpty'));
        return;
      }

      this.visible = true;
      this.qrcodeStatusText = this.$t('qrCodePage.generatingQrCode');
      this.loading = true;

      try {
        // 1. 批量生成 QR 码,每批 5 个并发(平衡性能和内存)
        const batchSize = 5;
        const allResults = [];

        for (let i = 0; i < shopList.length; i += batchSize) {
          const batch = shopList.slice(i, i + batchSize);
          const batchPromises = batch.map((shop, index) =>
            this.createSingleQRCode(shop, i + index)
          );
          const batchResults = await Promise.all(batchPromises);
          allResults.push(...batchResults);

          // 批次间短暂等待,避免阻塞主线程
          if (i + batchSize < shopList.length) {
            await new Promise((resolve) => setTimeout(resolve, 100));
          }
        }

        // 2. 过滤失败的结果(必须有 blob 才能打包下载)
        const validResults = allResults.filter((r) => r !== null && r.blob);

        if (validResults.length === 0) {
          this.loading = false;
          this.visible = false;
          this.$message.error(
            this.$t('qrCodePage.generatingQrFile') || 'Failed to generate QR code files'
          );
          return;
        }

        this.qrcodeStatusText = this.$t('qrCodePage.generatingQrFile');

        // 3. 用 JSZip 打包(用 binary 方式,避免 base64 解析问题)
        const zip = new JSZip();
        const img = zip.folder('images');

        validResults.forEach((result) => {
          img.file(result.fileName + '.jpg', result.blob, { binary: true });
        });

        const content = await zip.generateAsync({
          type: 'blob',
          compression: 'DEFLATE',
          compressionOptions: { level: 6 },
        });

        // 4. 校验 zip 文件
        const zipFile = new Blob([content], { type: 'application/zip' });
        if (zipFile.size < 100) {
          console.error('[JSZip] Generated zip file is too small:', zipFile.size, 'bytes');
          this.loading = false;
          this.visible = false;
          this.$message.error('ZIP file generation failed');
          return;
        }

        // 5. 触发下载
        const timestamp = new Date()
          .toISOString()
          .slice(0, 19)
          .replace(/:/g, '-');
        const filename = `QRcode_${timestamp}.zip`;

        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = URL.createObjectURL(zipFile);
        a.download = filename;
        a.click();
        URL.revokeObjectURL(a.href);
        a.remove();

        this.loading = false;
        this.visible = false;
        console.log(
          `[JSZip] ZIP generated: ${filename}, size=${zipFile.size} bytes, files=${validResults.length}`
        );
      } catch (err) {
        console.error('[QRCode] downloadQRcode error:', err);
        this.loading = false;
        this.visible = false;
      }
    },

    /**
     * 为页面展示批量生成二维码数据,存入 shopQrData
     * 复用 createSingleQRCode 的绘制结果,避免重复绘制逻辑
     */
    async generateShopQrData(shopList) {
      const items = [];
      for (let i = 0; i < shopList.length; i++) {
        const result = await this.createSingleQRCode(shopList[i], i);
        if (result) {
          const hasDataUrl = !!(result.dataUrl && result.dataUrl.length > 0);
          console.log(`[QRCode] 校验 #${i} dataUrl:`, hasDataUrl ? `OK (len=${result.dataUrl.length})` : 'EMPTY!');
          items.push({
            name: result.shopName,
            nameEn: result.shopNameEn,
            locationName: result.locationName,
            locationCode: result.locationCode,
            dataUrl: result.dataUrl || '',
          });
        }
      }
      this.shopQrData = items;
      console.log(`[QRCode] 页面展示已生成 ${items.length} 张二维码, shopQrData.length=${this.shopQrData.length}`);
    },

    /**
     * ShopM 子组件 shoplist-changed 事件处理
     * 当店铺选择变更时,自动生成二维码并展示到页面
     */
    onShopListChanged(shopList) {
      if (shopList && shopList.length > 0) {
        // 延迟到下一个 tick,确保 DOM 已就绪
        this.$nextTick(() => {
          this.generateShopQrData(shopList);
        });
      } else {
        // 店铺被清空时,同步清空展示
        this.shopQrData = [];
      }
    },
  },
  mounted() {
    this.$refs.sitem.ShopM = this.$refs.shopm;
    this.$refs.shopm.resetSites([]);
  },
};
</script>
